<template>
	<div class="user-center-page">
		<!-- 运输信息 + 右侧列 -->
		<div class="row-top">
			<!-- 集运订单 -->
			<div class="card transport-card animate__animated  ">
				<div class="card-title">
					<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/24.svg')"></el-image>
					<span>集运订单</span>
				</div>
				<!-- 全部订单 -->
				<div class="view-more" @click="link('/userPageLab/myOrderPage')">
					<span>{{$t('userCenter.t2')}}</span>
					<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/25.svg')"></el-image>
				</div>
				<div class="status-list">
					<!-- 待处理 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:1})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/51.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.waitProcessCount}}</div>
						<div class="stat-label">待处理</div>
					</div>
					<!-- 待支付 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:2})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/52.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.waitPayCount}}</div>
						<div class="stat-label">待支付</div>
					</div>
					<!-- 待发货 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:3})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/53.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.waitShipCount}}</div>
						<div class="stat-label">待发货</div>
					</div>
					<!-- 已发货 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:4})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/54.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.shippedCount}}</div>
						<div class="stat-label">已发货</div>
					</div>
					<!-- 已签收 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:5})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/55.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.signedCount}}</div>
						<div class="stat-label">已签收</div>
					</div>
					<!-- 已作废 -->
					<div class="status-item" @click="link('/userPageLab/myOrderPage',{status:6})">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/56.svg')"></el-image>
						<div class="stat-num">{{transportOrderStats.canceledCount}}</div>
						<div class="stat-label">已作废</div>
					</div>
				</div>
			</div>
			<!-- 我的包裹/代购订单 -->
			<div class="package-order-w f-bct">
				<!-- 我的包裹 -->
				<div class="card transport-card animate__animated  ">
					<div class="card-title">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/24.svg')"></el-image>
						<span>我的包裹</span>
					</div>
					<div class="status-list">
						<!-- 全部包裹 -->
						<div class="status-item" @click="link('/userPageLab/packageList',{status:0})">
							<el-image :src="require('@/static/add2/14.png')"></el-image>
							<div class="stat-num">{{packageStats.totalCount}}</div>
							<div class="stat-label">全部包裹</div>
						</div>
						<!-- 待入库 -->
						<div class="status-item" @click="link('/userPageLab/packageList',{status:1})">
							<el-image :src="require('@/static/add2/15.png')"></el-image>
							<div class="stat-num">{{packageStats.waitInboundCount}}</div>
							<div class="stat-label">待入库</div>
						</div>
						<!-- 已入库 -->
						<div class="status-item" @click="link('/userPageLab/packageList',{status:2})">
							<el-image :src="require('@/static/add2/16.png')"></el-image>
							<div class="stat-num">{{packageStats.inboundCount}}</div>
							<div class="stat-label">已入库</div>
						</div>
					</div>
				</div>
				<!-- 代购订单 -->
				<div class="card transport-card animate__animated  ">
					<div class="card-title">
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/24.svg')"></el-image>
						<span>代购订单</span>
					</div>
					<!-- 查看全部 -->
					<div class="view-more" @click="link('/userPageLab/myOrderPage')">
						<span>{{$t('userCenter.t2')}}</span>
						<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/25.svg')"></el-image>
					</div>
					<div class="status-list">
						<!-- 待付款 -->
						<div class="status-item" @click="link('/userPageLab/myshopOrder',{status:1})">
							<el-image :src="require('@/static/add2/17.png')"></el-image>
							<div class="stat-num">{{mallOrderStats.waitPayCount}}</div>
							<div class="stat-label">待付款</div>
						</div>
						<!-- 待审核 -->
						<div class="status-item" @click="link('/userPageLab/myshopOrder',{status:2})">
							<el-image :src="require('@/static/add2/18.png')"></el-image>
							<div class="stat-num">{{mallOrderStats.waitAuditCount}}</div>
							<div class="stat-label">待审核</div>
						</div>
						<!-- 采购中 -->
						<div class="status-item" @click="link('/userPageLab/myshopOrder',{status:3})">
							<el-image :src="require('@/static/add2/19.png')"></el-image>
							<div class="stat-num">{{mallOrderStats.purchasingCount}}</div>
							<div class="stat-label">采购中</div>
						</div>
						<!-- 售后 -->
						<div class="status-item" @click="link('/userPageLab/myshopOrder',{status:6})">
							<el-image :src="require('@/static/add2/20.png')"></el-image>
							<div class="stat-num">{{mallOrderStats.afterSaleCount}}</div>
							<div class="stat-label">售后</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 右侧 -->
			<div class="right-col">
				<!-- 通知 -->
				<div class="card news-sm-card animate__animated  ">
					<el-image class="news-sm-icon" :src="require('@/static/CodeBuddyAssets/31266_3151/23.svg')"></el-image>
					<div class="newsMsg" @click="link('/userPageLab/myNews')">
						<div class="news-sm-content" v-if="noticeArrOne">
							<div class="news-sm-title">{{noticeArrOne.noticeTitle}}</div>
							<div class="news-sm-desc line1" v-html="noticeArrOne.noticeContent"></div>
						</div>
						<el-image class="news-sm-arrow" :src="require('@/static/CodeBuddyAssets/31266_3151/22.svg')"></el-image>
					</div>
				</div>
				<!-- 仓库信息 -->
				<div class="card warehouse-card animate__animated  ">
					<div class="card-header-row">
						<div class="card-title-sm">
							<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/20.svg')"></el-image>
							<span>{{$t('userCenter.t3')}}</span>
						</div>
						<div class="view-more-sm" @click="link('/userPageLab/myPPoint')">
							<span>{{$t('userCenter.t4')}}</span>
							<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/21.svg')"></el-image>
						</div>
					</div>
					<div class="addr-item-w">
					<div v-for="(item,index) in warehouseArr"  :key="index" class="addr-item">
						<div class="addr-info">
							<div><span class="label">{{$t('userCenter.t5')}}：</span><span class="value">{{item.name}}</span></div>
							<div><span class="label">{{$t('userCenter.t6')}}：</span><span class="value">{{item.postcode}}</span></div>
							<div><span class="label">{{$t('userCenter.t7')}}：</span><span class="value">{{item.consignee}}</span></div>
							<div><span class="label">{{$t('userCenter.t8')}}：</span><span class="value">{{item.mobile}}</span></div>
							<div class="addr-full line1"><span class="label">{{$t('userCenter.t9')}}：</span><span class="value">{{item.province}}{{item.city}}{{item.address}}</span></div>
						</div>
						<div v-if="index < 2" class="addr-divider"></div>
					</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 快捷通道 -->
		<div class="card shortcut-card animate__animated  ">
			<div class="card-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/26.svg')"></el-image>
				<span>{{$t('userCenter.t10')}}</span>
			</div>
			<div class="shortcut-grid">
				<!-- 快件下单 -->
				<div class="shortcut-item" @click="link('/userPageLab/orderPage',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/21.png')"></el-image>
					<span>快件下单</span>
				</div>
				<!-- 集运订单 -->
				<div class="shortcut-item" @click="link('/userPageLab/myOrderPage',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/22.png')"></el-image>
					<span>集运订单</span>
				</div>
				<!-- 我的包裹 -->
				<div class="shortcut-item" @click="link('/userPageLab/packageList',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/23.png')"></el-image>
					<span>我的包裹</span>
				</div>
				<!-- 代购订单 -->
				<div class="shortcut-item" @click="link('/userPageLab/myshopOrder',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/24.png')"></el-image>
					<span>代购订单</span>
				</div>
				<!-- 优惠券 -->
				<div class="shortcut-item" @click="link('/userPageLab/myCoupon',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/25.png')"></el-image>
					<span>优惠券</span>
				</div>
				<!-- 我的收藏 -->
				<div class="shortcut-item" @click="link('/userPageLab/myCollect',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/26.png')"></el-image>
					<span>我的收藏</span>
				</div>
				<!-- 地址管理 -->
				<div class="shortcut-item" @click="link('/userPageLab/myAddr',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/28.png')"></el-image>
					<span>地址管理</span>
				</div>
				<!-- 仓库地址 -->
				<div class="shortcut-item" @click="link('/userPageLab/myPPoint',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/27.png')"></el-image>
					<span>仓库地址</span>
				</div>
				<!-- 物流查询 -->
				<div class="shortcut-item" @click="link('/logisticsQuery',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/29.png')"></el-image>
					<span>物流查询</span>
				</div>
				<!-- 运费估算 -->
				<div class="shortcut-item" @click="link('/freightEstimate',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/30.png')"></el-image>
					<span>运费估算</span>
				</div>
				<!-- 消息通知 -->
				<div class="shortcut-item" @click="link('/userPageLab/myNews',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/31.png')"></el-image>
					<span>消息通知</span>
				</div>
				<!-- 个人资料 -->
				<div class="shortcut-item" @click="link('/userPageLab/userProfile',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/32.png')"></el-image>
					<span>个人资料</span>
				</div>
				<!-- 常见问题 -->
				<div class="shortcut-item" @click="link('/userPageLab/faq',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/33.png')"></el-image>
					<span>常见问题</span>
				</div>
				<!-- 联系客服 -->
				<!-- <div class="shortcut-item">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/34.png')"></el-image>
					<span>联系客服</span>
				</div> -->
				<!-- 用户协议 -->
				<div class="shortcut-item" @click="link('/userPageLab/xieyi',{})">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/35.png')"></el-image>
					<span>用户协议</span>
				</div>
				<!-- 退出登录 -->
				<!-- <div class="shortcut-item">
					<el-image class="shortcut-icon-wrap" :src="require('@/static/add2/36.png')"></el-image>
					<span>退出登录</span>
				</div> -->
			</div>
		</div>
		<!-- 最新订单 -->
		<div class="card orders-card animate__animated  ">
			<div class="card-header-row">
				<div class="card-title">
					<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/65.svg')"></el-image>
					<span>{{$t('userCenter.t11')}}</span>
				</div>
				<!-- 查看全部 -->
				<div class="view-more" @click="link('/userPageLab/myOrderPage')">
					<span>{{$t('userCenter.t12')}}</span>
					<el-image :src="require('@/static/CodeBuddyAssets/31266_3151/66.svg')"></el-image>
				</div>
			</div>
			<!-- 暂无 -->
			<div class="zwBox" v-if="!orderList.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>{{$t('userCenter.t13')}}</p>
			</div>
			<!-- 列表 -->
			<div class="orders-table-wrap">
				<table class="orders-table">
					<thead>
						<tr>
							<th style="width:0.76rem;">{{$t('userCenter.t14')}}</th>
							<th style="width:1.68rem;">订单号</th>
							<th style="width:2.16rem;">{{$t('userCenter.t16')}}</th>
							<th style="width:1.20rem;">{{$t('userCenter.t17')}}</th>
							<th style="width:1.40rem;">{{$t('userCenter.t18')}}</th>
							<th style="width:1.60rem;">{{$t('userCenter.t19')}}</th>
							<th style="width:1.30rem;">{{$t('userCenter.t20')}}</th>
							<th style="width:0.80rem;">{{$t('userCenter.t21')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(order, index) in orderList" :key="index">
							<td>{{ index + 1 }}</td>
							<td>{{ order.orderSn }}</td>
							<td>{{ order.createTime }}</td>
							<td>{{ order.warehouseName }}</td>
							<td>{{ order.transportModeName }}</td>
							<td>{{ order.countryName}}</td>
							<td v-if="order.status==1">{{ $t('userCenter.t22') }}</td>
							<td v-if="order.status==2">{{ $t('userCenter.t23') }}</td>
							<td v-if="order.status==3">{{ $t('userCenter.t24') }}</td>
							<td v-if="order.status==4">{{ $t('userCenter.t25') }}</td>
							<td v-if="order.status==5">{{ $t('userCenter.t26') }}</td>
							<td v-if="order.status==6">{{ $t('userCenter.t27') }}</td>
							<td v-if="order.status==7">{{ $t('userCenter.t28') }}</td>
							<td class="action-cell" @click="link('/userPageLab/myOrderMsg',{id:order.id})">{{$t('userCenter.t29')}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- 分页 -->
			<div class="pagination-wrap" v-if="orderList.length">
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:total="totalOrder"
					:page-size="orderPageSize"
					:current-page.sync="orderCurrentPage"
					@current-change="handleOrderPageChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		noticelist,
		warehouselist,
		memberindex,
		transportOrderlist
	} from "/src/api/api.js"
	export default {
		name: 'UserCenter',
		data() {
			return {
				// 分页
				orderCurrentPage: 1,
				orderPageSize: 10,
				totalOrder: 175,
				// 公告列表
				noticeArr:[],
				noticeArrOne:'',
				// 仓库列表
				warehouseArr:[],
				// 订单列表
				orderList:[],
				// 个人页面用户相关信息
				mallOrderStats:'',
				packageStats:'',
				transportOrderStats:'',
			}
		},
		mounted() {
			this.noticelistF()
			this.warehouselistF()
			this.memberindexF()
			this.orderListF()
		},
		methods: {
			// 个人页面用户相关信息
			async memberindexF(){
				var res;
				res = await memberindex({});
				if(res.code==200){
					this.mallOrderStats = res.data.mallOrderStats
					this.packageStats = res.data.packageStats
					this.transportOrderStats = res.data.transportOrderStats
				}else{this.Tips(res.msg,'error')}
			},
			// 订单列表
			async orderListF(){
				var res;
				res = await transportOrderlist({
					pageNum: this.orderCurrentPage,
					pageSize: this.orderPageSize,
				});
				if(res.code==200){
					this.totalOrder = res.total
					this.orderList = res.rows
				}else{this.Tips(res.msg,'error')}
			},
			// 仓库列表(全部正常的)
			async warehouselistF(){
				var res;
				res = await warehouselist({});
				if(res.code==200){
					var originOptions = []
					res.rows.forEach((item)=>{
						originOptions.push({
							...item,
							label:item.name,
							value:item.id,
						})
					})
					this.warehouseArr = originOptions
				}else{this.Tips(res.msg,'error')}
			},
			// 公告列表
			async noticelistF(){
				var res;
				res = await noticelist({});
				if(res.code==200){
					this.noticeArr = res.data
					this.noticeArrOne = res.data[0]
				}else{this.Tips(res.msg,'error')}
			},
			// 分页变化
			handleOrderPageChange(page) {
				this.orderCurrentPage = page
				this.orderListF()
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-pagination__editor.el-input{
		margin-right: 8px;
		margin-left: 4px;
	}
	
	.user-center-page {
		position: relative;
		width: 100%;
		min-height: 14.04rem;
		background: #F8F8F8;
	}

	/* 卡片通用 */
	.card {
		position: relative;
		background: #fff;
		border-radius: 0.12rem;

		.card-title {
			display: flex;
			align-items: center;
			font-size: 0.20rem;
			font-weight: 500;
			color: #333333;

			.el-image {
				width: 0.02rem;
				height: 0.16rem;
				margin-right: 10px;
			}
		}

		.card-title-sm {
			display: flex;
			align-items: center;
			gap: 0.06rem;
			font-size: 0.20rem;
			font-weight: 500;
			color: #333333;

			.el-image {
				width: 0.18rem;
				height: 0.21rem;
			}
		}

		.view-more {
			display: flex;
			align-items: center;
			gap: 0.02rem;
			cursor: pointer;
			font-size: 0.14rem;
			color: #999999;

			.el-image {
				width: 0.16rem;
				height: 0.17rem;
			}
		}

		.card-header-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.view-more-sm {
			display: flex;
			align-items: center;
			cursor: pointer;
			font-size: 0.14rem;
			color: #999999;

			.el-image {
				width: 0.16rem;
				height: 0.16rem;
			}
		}
	}

	/* 运输信息 */
	.row-top {
		width: 15.93rem;
		margin-top: 24px;
	}

	.transport-card {
		width: 10.05rem;
		height: 2.43rem;
		padding: 0.24rem;
		box-sizing: border-box;

		.view-more {
			position: absolute;
			right: 0.32rem;
			top: 0.28rem;
		}

		.status-list {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 0.44rem;
			padding: 0 0.36rem;
		}

		.status-item {
			text-align: center;

			.el-image {
				width: 0.30rem;
				height: 0.30rem;
				margin-bottom: 0.14rem;
			}

			.stat-num {
				font-size: 0.24rem;
				font-weight: 500;
				font-weight: bold;
				font-family: MiSans, PingFang SC, sans-serif;
				color: #333333;
			}

			.stat-label {
				margin-top: 0.06rem;
				font-size: 0.18rem;
				font-weight: 400;
				color: #B1B3B7;
			}
		}
	}

	.right-col {
		position: absolute;
		left: 10.45rem;
		top: 0;
		width: 5.56rem;
		display: flex;
		flex-direction: column;
		gap: 0.19rem;
	}

	.warehouse-card {
		height: 3.64rem;
		padding: 0.22rem;
		box-sizing: border-box;
		.addr-item-w{
			height: 300px;
			overflow-y: scroll;
		}
		.addr-item {
			position: relative;

			&:first-child {
				// margin-top: 0.48rem;
			}
		}

		.addr-info {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			// height: 132px;
			padding: 22px 0;
			border-bottom: 1px solid #E1E1E1;

			&:first-child {
				border-bottom: none;
			}

			>div {
				width: 50%;
				margin-bottom: 12px;

				&:last-child {
					margin-bottom: 0;
				}
			}

			.label {
				font-size: 0.14rem;
				color: #B1B3B7;
				font-weight: 400;
			}

			.value {
				font-size: 0.14rem;
				color: #333333;
				font-weight: 400;
			}

			.addr-full {
				width: 100%;
			}
		}

		.addr-divider {
			width: 5.08rem;
			height: 0.01rem;
			background: #E1E1E1;
		}
	}

	.news-sm-card {
		padding: 0.20rem 0.24rem;
		box-sizing: border-box;

		.news-sm-icon {
			width: 0.43rem;
			height: 0.20rem;
			margin-bottom: 10px;
		}

		.newsMsg {
			display: flex;
			align-items: flex-start;

			.news-sm-content {
				width: calc(100% - 32px);

				.news-sm-title {
					font-size: 0.16rem;
					font-weight: 400;
					color: #222222;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.news-sm-desc {
					margin-top: 0.08rem;
					font-size: 0.14rem;
					font-weight: 400;
					color: #B1B3B7;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.news-sm-arrow {
				flex-shrink: 0;
				width: 0.20rem;
				height: 0.20rem;
				margin-left: 0.12rem;
				cursor: pointer;
			}
		}

	}

	/* 快捷通道 */
	.shortcut-card {
		width: 100%;
		height: 3.24rem;
		padding: 0.24rem 0rem;
		box-sizing: border-box;
		margin-top: 24px;
		.card-title{
			padding: 0 24px;
		}
		.shortcut-grid {
			display: flex;
			flex-wrap: wrap;
			margin-top: 0.28rem;
		}

		.shortcut-item {
			margin: 0 49px;
			margin-bottom: 28px;
			text-align: center;
			cursor: pointer;
			transition: opacity 0.3s;

			&:hover {
				opacity: 0.75;
			}

			.shortcut-icon-wrap {
				width: 0.58rem;
				height: 0.58rem;
				margin: 0 auto 0.13rem;
			}

			span {
				display: block;
				font-size: 0.14rem;
				font-weight: 500;
				color: #333333;
			}
		}
	}

	/* 最新订单 */
	.orders-card {
		width: 15.93rem;
		padding: 0.28rem;
		box-sizing: border-box;
		margin-top: 24px;

		.orders-table-wrap {
			margin-top: 0.24rem;
			border-radius: 0.10rem;
			border: 0.01rem solid #F0F0F0;
			overflow: hidden;
		}

		.orders-table {
			width: 100%;
			border-collapse: collapse;

			th,
			td {
				text-align: center;
				font-size: 0.14rem;
				padding: 0.27rem 0;
			}

			th {
				background: #FAFAFA;
				color: #333333;
				font-weight: 500;
			}

			td {
				color: #666666;
				font-weight: 400;
				border-bottom: 0.01rem solid #F0F0F0;
			}

			.action-cell {
				color: #0096FF;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	.pagination-wrap {
		padding: 0.20rem 0 0.10rem;
		display: flex;
		justify-content: center;
		margin-top: 12px;
		::v-deep .el-pagination {
			font-weight: 400;
			.el-pager li {
				min-width: 0.32rem;
				height: 0.32rem;
				line-height: 0.32rem;
				font-size: 0.14rem;
				border-radius: 0.04rem;
				margin: 0 0.02rem;
				color: #333;
				&.active {
					background: #0096FF;
					color: #fff;
					border-color: #0096FF;
				}
				&:hover { color: #0096FF; }
			}
			.el-pagination__total {
				font-size: 0.14rem;
				color: #999;
				margin-right: 0.12rem;
			}
			.btn-prev, .btn-next {
				min-width: 0.32rem;
				height: 0.32rem;
				line-height: 0.32rem;
				font-size: 0.14rem;
				border-radius: 0.04rem;
				&:hover { color: #0096FF; }
			}
			.el-pagination__jump {
				font-size: 0.14rem;
				color: #999;
				margin-left: 0.12rem;
				.el-input__inner {
					width: 0.50rem;
					height: 0.32rem;
					line-height: 0.32rem;
					font-size: 0.14rem;
					border-radius: 0.04rem;
				}
			}
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animate__animated {
			animation: none !important;
		}
	}
	.package-order-w{
		width: 10.05rem;
		margin-top: 24px;
		.transport-card{
			width: 490px;
		}
	}
</style>